





















import { Vue, Component } from 'vue-property-decorator'
import * as _ from 'underscore'
import config from '../../config'
import showDiv, { closeAll } from '@ivy/fts/showDiv'
import startPage from './startPage.vue'
import testPage from './testPage.vue'
import resultPage from './resultPage.vue'
import * as weixin from '@ivy/fts/weixin'
import * as utils from '@ivy/fts/utils'

@Component({
  components: {
    startPage,
    testPage,
    resultPage,
  },
})
export default class TalantTest extends Vue {
  progress = ''
  info
  result
  shareData = {
    title: `「测一测」你家宝宝身上隐藏着什么天赋？`,
    desc: `美国流行20年的天赋测试，科学认识宝宝的潜能`,
    link: '',
    imgUrl:
      'http://service.ivydad.com/course/7c457dbf-d7ba-a218-dbb7-e13489c8b0a8.jpg',
  }
  startTest() {
    this.progress = 'test'
  }
  async created() {
    await this.$store.login()
    let { data: info } = await this.$axios.get(
      '/api/activity/h5Activity/talentTest/getInfo'
    )
    this.info = info
    await this.setShare()
    let s = JSON.parse(utils.storeGet('talant_test_info') || '{}')
    if (s.progress === 'result' && s.result) {
      this.$title('测试结果')
      this.result = s.result
      this.progress = 'result'
      return
    }
    this.progress = 'start'
  }
  async setShare() {
    let options = {
      ...this.shareData,
      link: window.location.href,
    }
    weixin.weixinShareCallback(options, async f => {
      this.$Toast('分享成功！')
    })
  }
  getResult(result) {
    this.$title('测试结果')
    let highestScore = 0
    result = result
      .map(mod => {
        let score = mod.answers.reduceRight((pre, next) => +pre + +next, 0)
        highestScore = Math.max(highestScore, score)
        return {
          ...mod,
          total: mod.subjects.length,
          score,
        }
      })
      .map(mod => ({ ...mod, isHighest: mod.score === highestScore }))
    this.result = result
    this.progress = 'result'
    utils.storeSet(
      'talant_test_info',
      JSON.stringify({
        progress: 'result',
        result: this.result,
      })
    )
  }
  replay() {
    this.$title('宝宝天赋测试')
    this.result = null
    this.progress = 'start'
    utils.storeSet(
      'talant_test_info',
      JSON.stringify({
        progress: 'start',
      })
    )
  }
}
